// Danke-Seite: was jetzt passiert, wen man fragen kann (Kundenführung 08.10.2026).

import { useDraft } from "../hooks.ts";
import { PrivatErgebnis } from "./PrivatErgebnis.tsx";
import { DemoErgebnis } from "./DemoErgebnis.tsx";

export function Danke() {
  const d = useDraft();
  if (d.company.privat) return <PrivatErgebnis />;
  if (d.company.demo) return <DemoErgebnis />;
  const c = d.company;
  const tel = c.phone ? c.phone.replace(/[^\d+]/g, "") : null;
  return (
    <section className="danke">
      <div className="check-big" aria-hidden="true">
        ✓
      </div>
      <h1>Vielen Dank{d.survey.contactName ? `, ${d.survey.contactName}` : ""}!</h1>
      <p>
        Ihre Aufnahme ist bei <strong>{c.name}</strong> angekommen.
      </p>

      <section className="card naechste">
        <h2>So geht es weiter</h2>
        <ol className="steps">
          <li>{c.name} sieht sich Ihre Fotos und Angaben an.</li>
          <li>Sie bekommen ein Angebot – per {d.survey.email ? "E-Mail" : "Telefon"} oder wie mit Ihnen besprochen.</li>
          <li>Sie müssen nichts weiter tun.</li>
        </ol>
        {d.survey.email && <p className="hint">Eine Bestätigung ist an {d.survey.email} unterwegs.</p>}
      </section>

      {(c.phone || c.email) && (
        <p>
          Fragen oder etwas vergessen?
          <br />
          {c.phone && tel && <a href={`tel:${tel}`}>{c.phone}</a>}
          {c.phone && c.email && " · "}
          {c.email && <a href={`mailto:${c.email}`}>{c.email}</a>}
        </p>
      )}
      <p className="hint">Sie können diese Seite jetzt schließen.</p>
    </section>
  );
}
